export const addAdvancedEditingBlocksToState = (state, { type, data }) => {
  if (type !== 'ADD_ADVANCED_EDITING_BLOCKS_TO_STATE') {
    return state;
  }

  const newState = {
    ...state,
    blocks: {
      ...state.blocks,
      ...data,
    },
  };

  return newState;
};
